import UpcomingEventCardImage from "./components/UpcomingEventCardImage";
import UpcomingEventCardInfo from "./components/UpcomingEventCardInfo";

const UpcomingEventsCard = ({ item }) => {
  return (
    <div className="w-full gap-3 lg:gap-9  my-4 flex-row  lg:flex group">
      <UpcomingEventCardImage item={item} />
      <UpcomingEventCardInfo item={item} />
    </div>
  );
};

export default UpcomingEventsCard;
